// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BallScaleRippleMultiple_wrap_2qtxi","loader_simple":"BallScaleRippleMultiple_loader_simple_2ObVH","rotation":"BallScaleRippleMultiple_rotation_1sC2p"};